import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'XTextarea',
  props: {
    autoResize: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {

const props = __props

const xTextarea = ref();
const initHeight = ref(0);

const autoResizeProp = ref(props.autoResize);
onMounted(()=>{
    initHeight.value = parseFloat(((xTextarea.value.$el.scrollHeight-23)/xTextarea.value.$el.rows).toFixed(2));
})

const calcHight = () => {
    if (xTextarea.value.$el.scrollHeight >= initHeight.value*16 && xTextarea.value.autoResize) {
        autoResizeProp.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createBlock(_component_Textarea, {
    ref_key: "xTextarea",
    ref: xTextarea,
    class: _normalizeClass([__props.autoResize && !autoResizeProp.value? 'x1-textarea-scroll' : '', "x1-textarea-height"]),
    autoResize: false,
    onInput: calcHight
  }, null, 8, ["class"]))
}
}

})